import React from 'react';
import StartSurvey from './StartSurvey';
import EndSurvey from './EndSurvey';
import SatisfactionSurvey from './SatisfactionSurvey';

export default function SatisfactionSurveyComponent() {
  const [view, setView] = React.useState('START');

  const nextView = (next) => setView(next);

  switch (view) {
    case 'SURVEY':
      return <SatisfactionSurvey nextView={nextView} />;
    case 'END':
      return <EndSurvey />;
    default:
      return <StartSurvey nextView={nextView} />;
  }
}
